import DefaultContainer from '../default_container';
import './index_web.css';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useLink } from 'react-router-stack';
import { useSelector } from 'react-redux';
import avatars from '../../constants/avatars';
import Constants from '../../constants';
import { convertToDollars } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';

const MyProfileWeb = ({ balance, teamName }: any) => {
  const navigate = useLink();
  const { AccountTheme: theme } = useTheme();
  const { avatarId = 0, xpPoints = 0 } = useSelector((state: any) => state.user);
  const itemCardsStyle = {
    background: theme.myProfileItemCardsBg,
    boxShadow: theme.myProfileItemCardsBoxShadow,
    border: ` 1px solid ${theme.myProfileItemCardsBorder}`
  };
  const yourBalanceCardStyle = {
    background: theme.myProfileYourBalanceBg,
    boxShadow: theme.myProfileYourBalanceBoxShadow,
    border: ` 1px solid ${theme.myProfileYourBalanceBorder}`
  };
  const withdrawBtnStyle = {
    background: theme.myProfileWithdrawBtnBg
  };

  const allTransactionsBtnStyle = {
    backgroundColor: theme.myProfileAllTransactionsBtnBg,
    border: `2px solid ${theme.myProfileAllTransactionsBtnBorder}`,
    color: theme.myProfileAllTransactionsBtnBorder
  };
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="myprofile_wrapper">
        <div className="myprofile_player_detail_container">
          <div className="myprofile_user_profile_avatar_details">
            <div className="avatarSec__avatarWrap_web">
              <img src={avatars[avatarId]} className="myprofile_player_avatar_img" />
              <div
                className="avatarSec_edit_icon_img"
                onClick={() => navigate.push('/select_avatar')}>
                <Constants.Svgs.EditAvatar />
              </div>
            </div>

            <div className="myprofile_user_label">{teamName}</div>
            <div className="myprofile_id_label">998756876</div>
          </div>
          <div className="myprofile_games_winnings" style={itemCardsStyle}>
            <img src={Constants.Images.coin} />
            <p className="myprofile_gamesPlayed__txt">Game Winnings</p>
            <p>{`${convertToDollars(balance['totalBalance'])}`}</p>
          </div>
          <div className="myprofile_games_winnings" style={itemCardsStyle}>
            <img src={Constants.Images.xp} />
            <p className="myprofile_gamesPlayed__txt">Xp Earned</p>
            <p>{xpPoints}</p>
          </div>
          <div className="myprofile_games_played" style={itemCardsStyle}>
            <img src={Constants.Images.swords} />
            <p className="myprofile_gamesPlayed__txt">Games Played</p>
            <p>23,230</p>
          </div>
        </div>

        <div className="myprofile_balance_container">
          <p style={{ paddingLeft: '30%' }}>Your Balance</p>
          <div className="myprofile_wallet_balance_container" style={yourBalanceCardStyle}>
            <div className="myprofile_wallet_detail">
              <img src={Constants.Images.coin} />
              <p>{`${convertToDollars(balance['totalBalance'])}`}</p>
              <p className="myProfile__withdrawalLimit__txt">
                Withdrawal limit for today {convertToDollars(500)}/-
              </p>
            </div>
          </div>
        </div>
        <div className="myProfile__transactionsWithdraw__btn__container">
          <button
            className="myprofile_transactions_btn"
            onClick={() => navigate.push('/transaction_history')}
            style={allTransactionsBtnStyle}>
            All Transactions <ChevronRightIcon />
          </button>
          <button className="myprofile_withdrawal_btn" style={withdrawBtnStyle}>
            Withdraw
          </button>
        </div>
        <div className="myprofile_note_container">
          <div style={{ paddingLeft: '8%' }}>Note:</div>
          <div className="myprofile_terms_container">
            <p>1. It may take up to 48 hours for the winnings to added to your wallet</p>
            <p>2. Common reasons for transaction failure while withdrawing your winnings</p>
            <p className="myProfile__termsRejection__txt">You donot have a paytm account</p>
            <p className="myProfile__termsRejection__txt">You KYC on paytm is not complete</p>
            <p className="myProfile__termsRejection__txt">
              You may have crossed your monthly limit on paytm
            </p>
            <p>
              3. It may take upto 24 hours after withdrawal request for the money to reflect in your
              paytm wallet
            </p>
          </div>
        </div>
        {/* <div className="myprofile_withdrawal_container"> */}
      </div>
      {/* </div> */}
    </DefaultContainer>
  );
};

export default MyProfileWeb;
